import React from 'react';

import './pinLoader.scss';

const PinLoader = () => {
  return <div className='pin-loader' />;
};

export default PinLoader;
